import clsx from 'clsx'
import {useFormik} from 'formik'
import React, {useState} from 'react'
import {Spinner} from 'react-bootstrap'
import {useIntl} from 'react-intl'
import {Link, useParams} from 'react-router-dom'
import * as Yup from 'yup'
import useAuth from '../../../../hooks/useAuth'
import {KTSVG} from '../../../../_metronic/helpers'
export function ResetPassword() {
  const intl = useIntl()
  const initialValues = {
    password: '',
    repeatPassword: '',
  }

  const {token} = useParams()
  const {actionLoading, resetPassword} = useAuth()

  const forgotPasswordSchema = Yup.object().shape({
    password: Yup.string()
      .min(3, intl.formatMessage({id: 'FORM.ERROR.SYMBOL.MIN'}, {min: 3}))
      .max(50, intl.formatMessage({id: 'FORM.ERROR.SYMBOL.MAX'}, {max: 50}))
      .required(intl.formatMessage({id: 'FORM.ERROR.REQUIRED'})),
    repeatPassword: Yup.string()
      .oneOf([Yup.ref('password')], intl.formatMessage({id: 'FORM.ERROR.PASSWORD_DOES_NOT_MATCH'}))
      .required(intl.formatMessage({id: 'FORM.ERROR.REQUIRED'})),
  })

  const [hasErrors, setHasErrors] = useState<boolean | undefined>(undefined)
  const [isRequestPending, setIsRequestPending] = useState(false)
  
  const formik = useFormik({
    initialValues,
    validationSchema: forgotPasswordSchema,
    onSubmit: (values, {setStatus, setSubmitting}) => {
      if (isRequestPending) {
        return
      }
      
      setIsRequestPending(true)
      resetPassword({password: values.password, token: token!})
        .then((action) => {
          const payload: any = action.payload
          if (payload.success) {
            setHasErrors(false)
          } else {
            setHasErrors(true)
          }
        })
        .finally(() => {
          setSubmitting(false)
          setIsRequestPending(false)
        })
    },
  })

  const [showPasswords, setShowPasswords] = React.useState(() => ({
    password: false,
    repeatPassword: false,
  }))
  return (
    <>
      <form
        className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework'
        noValidate
        id='kt_login_password_reset_form'
        onSubmit={formik.handleSubmit}
      >
        <div className='text-center mb-10'>
          {/* begin::Title */}
          <h1 className='text-dark mb-3'>{intl.formatMessage({id: 'MENU.RESET_PASSWORD'})}</h1>
          {/* end::Title */}
        </div>

        {/* begin::Title */}
        {hasErrors === true && (
          <div className='mb-lg-15 alert alert-danger'>
            <div className='alert-text font-weight-bold'>
              {intl.formatMessage({id: 'ERROR.PASSWORD_RESET'})}
            </div>
          </div>
        )}

        {hasErrors === false && (
          <div className='mb-10 bg-light-info p-8 rounded'>
            {intl.formatMessage({id: 'SUCCESS.PASSWORD_RESET'})}
            <div className='text-info'></div>
          </div>
        )}
        {/* end::Title */}

        {/* begin::Form group */}
        {hasErrors === false ? (
          <div className='fv-row my-10 d-flex justify-content-center'>
            <Link to='/auth/login'>
              <button
                type='button'
                id='kt_login_password_reset_form_cancel_button'
                className='btn btn-lg btn-primary fw-bolder'
              >
                {intl.formatMessage({id: 'MENU.LOGIN'})}
              </button>
            </Link>
          </div>
        ) : (
          <>
            <div className='fv-row mb-10'>
              <label className='form-label fs-6 fw-bolder text-dark'>
                {intl.formatMessage({id: 'INPUT.PASSWORD.LABEL'})}
              </label>
              <div className='position-relative d-flex align-items-center'>
                <input
                  type={showPasswords.password ? 'text' : 'password'}
                  autoComplete='off'
                  placeholder={intl.formatMessage({id: 'MENU.PASSWORD'})}
                  {...formik.getFieldProps('password')}
                  className={clsx(
                    'form-control form-control-lg form-control-solid',
                    {
                      'border border-danger': formik.touched.password && formik.errors.password,
                    },
                    {
                      '': formik.touched.password && !formik.errors.password,
                    }
                  )}
                />
                <div className='position-absolute' style={{right: '20px'}}>
                  {showPasswords.password ? (
                    <a
                      className='_cursor-pointer'
                      onClick={() =>
                        setShowPasswords({...showPasswords, password: !showPasswords.password})
                      }
                    >
                      <KTSVG
                        path='/media/svg/stolen/Visible.svg'
                        className='svg-icon-2x svg-icon-white'
                      />
                    </a>
                  ) : (
                    <a
                      className='_cursor-pointer'
                      onClick={() =>
                        setShowPasswords({...showPasswords, password: !showPasswords.password})
                      }
                    >
                      <KTSVG
                        path='/media/svg/stolen/Hidden.svg'
                        className='svg-icon-2x svg-icon-white'
                      />
                    </a>
                  )}
                </div>
              </div>
            </div>

            <div className='fv-row mb-10'>
              <label className='form-label fs-6 fw-bolder text-dark'>
                {intl.formatMessage({id: 'INPUT.REPEAT_PASSWORD.LABEL'})}
              </label>
              <div className='position-relative d-flex align-items-center'>
                <input
                  type={showPasswords.repeatPassword ? 'text' : 'password'}
                  autoComplete='off'
                  placeholder={intl.formatMessage({id: 'INPUT.REPEAT_PASSWORD.PLACEHOLDER'})}
                  {...formik.getFieldProps('repeatPassword')}
                  className={clsx(
                    'form-control form-control-lg form-control-solid',
                    {
                      'border border-danger':
                        formik.touched.repeatPassword && formik.errors.repeatPassword,
                    },
                    {
                      '': formik.touched.repeatPassword && !formik.errors.repeatPassword,
                    }
                  )}
                />
                <div className='position-absolute' style={{right: '20px'}}>
                  {showPasswords.repeatPassword ? (
                    <a
                      className='_cursor-pointer'
                      onClick={() =>
                        setShowPasswords({
                          ...showPasswords,
                          repeatPassword: !showPasswords.repeatPassword,
                        })
                      }
                    >
                      <KTSVG
                        path='/media/svg/stolen/Visible.svg'
                        className='svg-icon-2x svg-icon-white'
                      />
                    </a>
                  ) : (
                    <a
                      className='_cursor-pointer'
                      onClick={() =>
                        setShowPasswords({
                          ...showPasswords,
                          repeatPassword: !showPasswords.repeatPassword,
                        })
                      }
                    >
                      <KTSVG
                        path='/media/svg/stolen/Hidden.svg'
                        className='svg-icon-2x svg-icon-white'
                      />
                    </a>
                  )}
                </div>
              </div>
            </div>

            {/* end::Form group */}

            {/* begin::Form group */}
            <div className='d-flex flex-wrap justify-content-center pb-lg-0'>
              {actionLoading || isRequestPending ? (
                <button className='btn btn-primary btn-lg fw-bolder me-4' disabled>
                  <Spinner role='status' animation='border' />
                </button>
              ) : (
                <>
                  <Link to='/auth/login'>
                    <button
                      type='button'
                      id='kt_login_password_reset_form_cancel_button'
                      className='btn btn-lg fw-bolder'
                      disabled={formik.isSubmitting || isRequestPending}
                    >
                      {intl.formatMessage({id: 'MENU.CANCEL'})}
                    </button>
                  </Link>
                  <button
                    type='submit'
                    className='btn btn-primary btn-lg fw-bolder me-4'
                    disabled={formik.isSubmitting || !formik.isValid || isRequestPending}
                  >
                    {intl.formatMessage({id: 'MENU.SUBMIT'})}
                  </button>
                </>
              )}
            </div>
          </>
        )}

        {/* end::Form group */}
      </form>
    </>
  )
}
